var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.lunchesSortedByDateDes),function(lunch){return _c('LunchReport',{key:("lunch-" + (lunch.id)),attrs:{"lunch":lunch,"display-restaurant-name":_vm.displayRestaurantName}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }